import Vue from 'vue';
import createRouter from './router';
import { createStore } from 'g-public/vuex';

import APP from './App';
import Store from './vuex'

import Lazy from 'g-public/directives/lazy';
import 'g-public/filters/format';
import 'g-public/filters/linkAdapt'
import Href from 'g-public/directives/href';
import Report from 'g-public/directives/report';
import { Message, Popover } from '@bilibili/van';
// import { sentryInit } from './utils/sentry';

import './styles/common.less';

if (process.env.VUE_ENV === 'client') {
    Vue.use(Lazy, { preload: 100 });
    // Vue.use(Popover);
    Vue.use(Report);
    Vue.use(Href);

    window.funcThrottle = require('throttle-debounce/throttle');
    window.supportPassive = false;
    window.GeminiScrollbar = require('gemini-scrollbar');
    try {
        let opts = Object.defineProperty({}, 'passive', {
            get: function() {
                window.supportPassive = true;
            }
        });
    } catch (e) {}
    Vue.prototype.$message = Message;
}

// function lifeCycleShim(options, store) {
//     // 客户端接入
//     if (process.env.VUE_ENV === 'client') {
//         if (options.sentry && options.sentry.dsn) {
//             const mounted = options.app.mounted;

//             options.app.mounted = function() {
//                 sentryInit({
//                     dsn: options.sentry.dsn
//                 }, store);
//                 mounted.apply(this);
//             };
//         }
//     }
// }

export function createApp(options) {
    // debug('初始化开始');
    const router = createRouter();
    const store = createStore(Store);
    // if (options.plugin && options.plugin.lazy) {
    //     Vue.use(Lazy, {preload: 100});
    // }
    // if (store && router) {
    //     sync(store, router);
    // }

    // 实例生命周期注入部分逻辑
    // lifeCycleShim(options, store);

    const app = new Vue({
        store,
        router,
        ssrContext: options.ssrContext,
        render: h => h(APP)
    });

    return { app, router, store };
}
